/**
 * Scroll depth: one passive scroll listener, math in rAF (no layout thrash),
 * scroll_25/50/75/100 once per page view, feeds max depth + activity pings.
 */
import { safe } from '../core/safe';
import { st } from '../core/state';
import { enqueue } from '../core/track';
import { depth } from './activity';
import { doc, navH, on } from './util';

let fired = 0;
let raf = 0;

const measure = safe(() => {
	raf = 0;
	const d = doc.scrollingElement || doc.documentElement;
	const h = d.scrollHeight;
	const p = h > 0 ? Math.min(100, ((d.scrollTop + innerHeight) / h) * 100) : 0;
	depth(p);
	for (let i = 1; i < 5; i++) {
		if (p >= i * 25 && !(fired & (1 << i)) && st.auto_.scroll) {
			fired |= 1 << i;
			enqueue('scroll_' + i * 25);
		}
	}
});

export function initScroll(): void {
	navH.push(() => {
		fired = 0;
	});
	on(window, 'scroll', () => {
		if (!raf) raf = requestAnimationFrame(measure);
	});
}
